// This file autogenerated by generate-asset-types.js
// Do not modify it by hand. Any changes will be overwritten.
const sounds = {
  snap: require("url:./audio/snap.flac"),
  sheetSnap: require("url:./audio/sheet_snap.wav"),
  paddle1: require("url:./audio/paddle-1.flac"),
  boomSlam: require("url:./audio/boom_slam.wav"),
  bail1: require("url:./audio/bail-1.flac")
};
export type SoundName = keyof typeof sounds;

const images = {
  favicon: require("url:./images/favicon.png")
};
export type ImageName = keyof typeof images;

const fonts = {
  spectralLight: require("url:./fonts/Spectral-Light.woff2"),
  spectralRegular: require("url:./fonts/Spectral-Regular.woff2"),
  spectralSemiBold: require("url:./fonts/Spectral-SemiBold.woff2"),
  tangerineBold: require("url:./fonts/Tangerine-Bold.woff2"),
  tangerineRegular: require("url:./fonts/Tangerine-Regular.woff2"),
  youngSerifRegular: require("url:./fonts/YoungSerif-Regular.woff2")
};
export type FontName = keyof typeof fonts;

const levels = {
  vendoviIsland: require("./levels/vendovi-island.level.json"),
  sanJuanIslands: require("./levels/san-juan-islands.level.json"),
  islesOfScilly: require("./levels/isles-of-scilly.level.json"),
  default: require("./levels/default.level.json"),
  apostleIslands: require("./levels/apostle-islands.level.json")
};
export type LevelName = keyof typeof levels;

const terrains = {
  vendoviIsland: "/assets/levels/vendovi-island.terrain",
  sanJuanIslands: "/assets/levels/san-juan-islands.terrain",
  islesOfScilly: "/assets/levels/isles-of-scilly.terrain",
  apostleIslands: "/assets/levels/apostle-islands.terrain"
};
export type TerrainName = keyof typeof terrains;

const entityDefs = {

}
export type EntityDefName = keyof typeof entityDefs;

const jsonBlobs = {

};

const wavemeshes = {
  vendoviIsland: "/assets/levels/vendovi-island.wavemesh",
  sanJuanIslands: "/assets/levels/san-juan-islands.wavemesh",
  islesOfScilly: "/assets/levels/isles-of-scilly.wavemesh",
  default: "/assets/levels/default.wavemesh",
  apostleIslands: "/assets/levels/apostle-islands.wavemesh"
};
export type WavemeshName = keyof typeof wavemeshes;

const windmeshes = {
  vendoviIsland: "/assets/levels/vendovi-island.windmesh",
  sanJuanIslands: "/assets/levels/san-juan-islands.windmesh",
  islesOfScilly: "/assets/levels/isles-of-scilly.windmesh",
  default: "/assets/levels/default.windmesh",
  apostleIslands: "/assets/levels/apostle-islands.windmesh"
};
export type WindmeshName = keyof typeof windmeshes;

const trees = {
  vendoviIsland: "/assets/levels/vendovi-island.trees",
  sanJuanIslands: "/assets/levels/san-juan-islands.trees",
  islesOfScilly: "/assets/levels/isles-of-scilly.trees",
  default: "/assets/levels/default.trees",
  apostleIslands: "/assets/levels/apostle-islands.trees"
};
export type TreesName = keyof typeof trees;

export const RESOURCES = { sounds, images, fonts, levels, terrains, entityDefs, jsonBlobs, wavemeshes, windmeshes, trees };
